export default __webpack_public_path__ + "static/media/tel.c0d020ce.svg";